import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/chatboat/Chatbotwidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/DoctorsTestimonialsSectionDesktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/DoctorsTestimonialsSectionMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/FindYourAtomSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/GlobalMapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/PromiseIconsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/QualityBarSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/TimeToSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/TrustedFacesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/home/TrustStatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/components/ui/language-selection-popup.tsx");
